import { isFeatureEnabled } from '@shared/features'
import { ConfigService } from '@/services/ConfigService'
import { isProduction } from '@/utils/env'

/**
 * Whether the diagnostics-bundle feature is on for this deployment.
 *
 * Prefers the backend's resolved verdict from `/api/config` over the static
 * flag, so a default-off feature can actually be switched on per deployment.
 * `undefined` from the resolver means "no opinion" — config failed to load, or
 * the feature is absent from the map — and falls back to the static default.
 *
 * Shared by the shortcut, the host and the menu item so the three cannot
 * disagree about whether the feature exists. A second, narrower copy of a gate
 * like this is how AGI ended up with a dropdown that hid an affordance the
 * hotkey still offered.
 */
export function isSupportBundlesEnabled(): boolean {
  return (
    ConfigService.getResolvedFeature('support_bundles') ??
    isFeatureEnabled('support_bundles', isProduction())
  )
}
